export const ADD_STATISTICS_DATA = "ADD_STATISTICS_DATA";
export const CLEAR_ADMIN_DATA = "CLEAR_ADMIN_DATA";
